import { render, staticRenderFns } from "./activity-data-details.vue?vue&type=template&id=4681a00f&scoped=true&"
import script from "./activity-data-details.vue?vue&type=script&lang=js&"
export * from "./activity-data-details.vue?vue&type=script&lang=js&"
import style0 from "./activity-data-details.vue?vue&type=style&index=0&id=4681a00f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4681a00f",
  null
  
)

export default component.exports